export default "__VITE_ASSET__BPVgY82q__"